module.exports = __webpack_public_path__ + "img/11_26@3x.d26539b3.png";